import { useState } from "react";
import useBrandList from "../../../hooks/brands/useBrandList";
import { v4 as uuid } from "uuid";
import { Box, Typography } from "@mui/material";

export default function useBrandBody({ searchBy, keyWord, brandSelectList, searchValue }) {
  const [pagi, setPagi] = useState({
    limit: 50,
    skip: 0,
  });
  const {
    data: brand,
    isLoading,
    error,
  } = useBrandList({
    limit: pagi?.limit,
    skip: pagi?.skip,
    searchField: !!searchValue ? undefined : !!searchBy ? brandSelectList[searchBy - 1]?.value : brandSelectList[0]?.value,
    searchValue: !!keyWord ? keyWord : (undefined ?? searchValue),
    sortField: "name",
    sortOrder: "asc",
    manufacturer: searchValue === null ? undefined : searchValue,
  });

  const header = [
    {
      id: uuid(),
      title: "STT",
      align: "center",
    },
    {
      id: uuid(),
      title: "Tên thương hiệu",
      align: "center",
    },
    {
      id: uuid(),
      title: "Nhà sản xuất",
      align: "center",
    },
    {
      id: uuid(),
      title: "Thao tác",
      align: "center",
    },
  ];

  const bodyList = Array.isArray(brand?.data)
    ? brand.data.map((v, index) => ({
        ...v,
        no: <Typography align="center">{index + 1}</Typography>,
        brandName: (
          <Box>
            <Typography align="center">{v?.name}</Typography>
            <Typography
              align="center"
              fontWeight="bold"
              fontSize="12px"
            >
              ({v?.code ?? "-"})
            </Typography>
          </Box>
        ),
        manufacturerName: <Typography align="center">{v?.manufacturer?.name}</Typography>,
      }))
    : [];

  const sortData = ["no", "brandName", "manufacturerName"];
  return {
    bodyList,
    sortData,
    isLoading,
    setPagi,
    header,
    error,
    total: brand?.count,
    pagi,
  };
}
